<template>
  <div class="study-rank">
    <chooseState :chooses="chooses"></chooseState>
    <studyTable :tableData="tableDataTemp" :pages="pages" :num="num" :columns="columns"></studyTable>
  </div>
</template>
<script>
import chooseState from "./module/_studyChoose";
import studyTable from "./module/_studyTable";
export default {
  data() {
    return {
      tableData: [
        // { studyObject: "大石桥街道", number: 600 },
        // { studyObject: "王家村", number: 300 }
      ],
      columns: [
        { name: "学习对象", prop: "town" },
        { name: "学习条数", prop: "count" }
      ],
      chooses: [
        { name: "按乡/镇查询" },
        { name: "按村/社区查询" },
        { name: "按人查询" },
        { name: "按学习信息查询" }
      ],
      tableDataTemp: [],
      pages: 1,
      num:0,
      choosed:1
    };
  },
  components: {
    chooseState,
    studyTable
  },
  methods: {
    getMsg() {
      // console.log(this.choosed);
      this.tableDataTemp = [];

      this.axios
        .post("/api/Statistics/Ranking", {
          c2town: sessionStorage.getItem("town"),
          c1roleid: sessionStorage.getItem("roleid"),
          c1status: this.choosed,
          c2name: sessionStorage.getItem("token")
        })
        .then(e => {
          console.log(e.data);
          switch (e.data.code) {
            case 0:
              this.tableData = e.data.msg;
              this.num = this.tableData.length
              this.tableData.some((item, index) => {
                if (index == 10) return true;
                else {
                  this.tableDataTemp.push(item);
                }
              });
              this.pages = Number.parseInt(
                this.tableData.length % 10 > 0
                  ? this.tableData.length / 10 + 1
                  : this.tableData.length /10
              );
              console.log(this.pages);
              break;

            default:
              break;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted(){
    this.getMsg()
  }
};
</script>
<style lang='scss' scoped>
.study-rank {
  padding-top: 1.1rem;
  font-size: 0.3rem;
}
</style>